import * as preact from "preact";

import stores from "stores/stores";
import * as webSearch from "webSearch";

/** As many as are worth scrolling through, before "See all" */
const shownCount = 12;

interface State {
  popularDomains: webSearch.PopularDomain[] | null;
}

/**
 * Discover's row of websites in the iOS app, scrolling sideways: its
 * browser, to search or visit any site, then the sites popular with the
 * language's learners, and "See all ›" for the Websites page
 */
export default class WebsitesRowView extends preact.Component<{}, State> {
  state: State = { popularDomains: null };

  async componentDidMount() {
    this.setState({
      popularDomains: await webSearch.fetchPopularDomains(
        stores.user.currentLearningLanguage.value
      ),
    });
  }

  render() {
    const language = stores.user.currentLearningLanguage.value;
    return (
      <section class="websitesRow">
        <div class="discoverSectionHeader">
          <h2>Websites</h2>
          <a href={`/${language}/links`}>See all ›</a>
        </div>
        <div class="websiteTiles">
          <a
            class="websiteTile searchTile"
            href={webSearch.searchHomeURL(language)}
            onClick={webSearch.openInAppBrowser}
          >
            <strong>
              <i class="icon-search" aria-hidden="true"></i> Search the web
            </strong>
            <small>or open any site</small>
          </a>
          {(this.state.popularDomains ?? [])
            .slice(0, shownCount)
            .map((domain) => (
              <a
                key={domain._id}
                class="websiteTile"
                href={webSearch.popularDomainURL(domain)}
                onClick={webSearch.openInAppBrowser}
              >
                <strong>{domain.title || domain.domainName}</strong>
                <small>{domain.domainName}</small>
              </a>
            ))}
        </div>
      </section>
    );
  }
}
